/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatePostDto } from '../models/CreatePostDto';
import type { MessageResponse } from '../models/MessageResponse';
import type { PostDetailResponse } from '../models/PostDetailResponse';
import type { UpdatePostDto } from '../models/UpdatePostDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PostsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Create a post
     * Create a new post for the specified society. Requires SOCIETY_OWNER or ADMIN role and ownership of the society.
     * @returns PostDetailResponse Post created successfully.
     * @throws ApiError
     */
    public postsControllerCreate({
        societyId,
        requestBody,
    }: {
        /**
         * Society unique identifier
         */
        societyId: string,
        requestBody: CreatePostDto,
    }): CancelablePromise<PostDetailResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/societies/{societyId}/posts',
            path: {
                'societyId': societyId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. SOCIETY_OWNER or ADMIN role required and must own the society.`,
                404: `Society not found.`,
            },
        });
    }
    /**
     * List posts
     * Returns a paginated list of posts for the specified society. Any authenticated user can access.
     * @returns any List of posts.
     * @throws ApiError
     */
    public postsControllerFindAll({
        societyId,
        page = 1,
        limit = 20,
        sortBy,
        sortOrder = 'desc',
        search,
        mine,
    }: {
        /**
         * Society unique identifier
         */
        societyId: string,
        /**
         * Page number
         */
        page?: number,
        /**
         * Items per page (max 200)
         */
        limit?: number,
        /**
         * Field to sort by
         */
        sortBy?: string,
        /**
         * Sort order (asc/desc)
         */
        sortOrder?: 'asc' | 'desc',
        /**
         * Search posts by title
         */
        search?: string,
        /**
         * Filter to only return posts authored by the current user
         */
        mine?: boolean,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/societies/{societyId}/posts',
            path: {
                'societyId': societyId,
            },
            query: {
                'page': page,
                'limit': limit,
                'sortBy': sortBy,
                'sortOrder': sortOrder,
                'search': search,
                'mine': mine,
            },
            errors: {
                401: `Unauthorized.`,
                404: `Society not found.`,
            },
        });
    }
    /**
     * Get post detail
     * Returns a single post with full details including images. Increments view count. Any authenticated user can access.
     * @returns PostDetailResponse Post found.
     * @throws ApiError
     */
    public postsControllerFindOne({
        societyId,
        id,
    }: {
        /**
         * Society unique identifier
         */
        societyId: string,
        /**
         * Post unique identifier
         */
        id: string,
    }): CancelablePromise<PostDetailResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/societies/{societyId}/posts/{id}',
            path: {
                'societyId': societyId,
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                404: `Post not found.`,
            },
        });
    }
    /**
     * Update a post
     * Updates a post. Requires SOCIETY_OWNER or ADMIN role and ownership of the society.
     * @returns PostDetailResponse Post updated successfully.
     * @throws ApiError
     */
    public postsControllerUpdate({
        societyId,
        id,
        requestBody,
    }: {
        /**
         * Society unique identifier
         */
        societyId: string,
        /**
         * Post unique identifier
         */
        id: string,
        requestBody: UpdatePostDto,
    }): CancelablePromise<PostDetailResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/societies/{societyId}/posts/{id}',
            path: {
                'societyId': societyId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. SOCIETY_OWNER or ADMIN role required and must own the society.`,
                404: `Post not found.`,
            },
        });
    }
    /**
     * Delete a post
     * Deletes a post. Requires SOCIETY_OWNER or ADMIN role and ownership of the society.
     * @returns MessageResponse Post deleted successfully.
     * @throws ApiError
     */
    public postsControllerRemove({
        societyId,
        id,
    }: {
        /**
         * Society unique identifier
         */
        societyId: string,
        /**
         * Post unique identifier
         */
        id: string,
    }): CancelablePromise<MessageResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/societies/{societyId}/posts/{id}',
            path: {
                'societyId': societyId,
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. SOCIETY_OWNER or ADMIN role required and must own the society.`,
                404: `Post not found.`,
            },
        });
    }
    /**
     * Toggle like on a post
     * Toggles the like on a post for the current user. If already liked, removes the like; otherwise, adds it. Returns the updated post with the liked status.
     * @returns PostDetailResponse Post liked successfully.
     * @throws ApiError
     */
    public postsControllerToggleLike({
        societyId,
        id,
    }: {
        /**
         * Society unique identifier
         */
        societyId: string,
        /**
         * Post unique identifier
         */
        id: string,
    }): CancelablePromise<PostDetailResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/societies/{societyId}/posts/{id}/like',
            path: {
                'societyId': societyId,
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                404: `Post not found.`,
            },
        });
    }
}
